import { useState } from 'react';
import type { Key } from 'react';
import type { AppTableColumns, AppTableSingleColumn } from 'shared/UI/UIKit/Table';

export const useFilteredColumns = (
  columns: AppTableColumns<any>,
  hiddenByDefaultKeys?: string[],
) => {
  const [visibleKeys, setVisibleKeys] = useState<Key[]>(() =>
    columns
      .map((column) => (column as AppTableSingleColumn<any>).key)
      .filter((key) => !hiddenByDefaultKeys?.includes(String(key))),
  );

  const filteredColumns = columns.filter((column) =>
    visibleKeys.includes((column as AppTableSingleColumn<any>).key),
  );
  const hiddenColumns = columns.filter(
    (column) => !visibleKeys.includes((column as AppTableSingleColumn<any>).key),
  );

  return {
    visibleKeys,
    setVisibleKeys,
    filteredColumns,
    hiddenColumns,
  };
};
